import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, fmtDate, inr } from "@/lib/api";
import { DataTable, Money, PageHeader } from "@/components/common";

const BUCKET_LABELS = { current: "Current", "1-30": "1–30 days", "31-60": "31–60 days", "61-90": "61–90 days", "90+": "90+ days" };

export default function Payables() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/reports/payables").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return <div className="py-24 text-center"><Loader2 className="h-6 w-6 animate-spin inline text-[#5C6B69]" /></div>;
  return (
    <div data-testid="payables-page">
      <PageHeader title="Accounts Payable" subtitle={`Unpaid vendor bills: ${inr(data.totals.payable)}`} testid="payables-header" />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
        {Object.keys(BUCKET_LABELS).map((b) => (
          <div key={b} className="bg-white border border-[#E5E0D8] rounded-xl p-4 shadow-sm">
            <div className="text-xs font-semibold uppercase tracking-wide text-[#5C6B69]">{BUCKET_LABELS[b]}</div>
            <div className="num text-xl font-bold mt-1 text-[#0D4F4A]">{inr(data.aging[b] || 0)}</div>
          </div>
        ))}
      </div>
      <DataTable testid="payables-table"
        columns={[
          { key: "vendor", label: "Vendor", render: (r) => <span className="font-medium">{r.vendor}</span> },
          { key: "invoice_no", label: "Vendor Bill", render: (r) => r.invoice_no || "—" },
          { key: "date", label: "Date", render: (r) => fmtDate(r.date) },
          { key: "category", label: "Category" },
          { key: "amount", label: "Amount Due", align: "right", render: (r) => <Money value={r.amount} className="font-semibold text-red-600" /> },
          { key: "days", label: "Days", align: "right", render: (r) => <span className="num">{r.days}</span> },
          { key: "bucket", label: "Aging", render: (r) => (
            <span className="text-xs font-semibold bg-[#FAF8F5] border border-[#E5E0D8] rounded-full px-2 py-0.5">{BUCKET_LABELS[r.bucket]}</span>) },
        ]}
        rows={data.rows} empty="No payables due." />
    </div>
  );
}
